import React, { useEffect, useState } from 'react';
import './Toast.css';

export default function Toast({ id, message, variant = 'info', onDismiss }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(t);
  }, []);

  return (
    <div
      role="status"
      className={`toast toast--${variant} ${visible ? 'toast--visible' : ''}`}
      onClick={onDismiss}
    >
      <span className="toast-message">{message}</span>
      <button type="button" className="toast-dismiss" onClick={(e) => { e.stopPropagation(); onDismiss(); }} aria-label="Dismiss">
        ×
      </button>
    </div>
  );
}
